module.exports = __webpack_public_path__ + "static/media/Angel-Body.f20a7d51.png";